import './theme.less'

// import Affix from 'iview/src/components/affix'
import Alert from 'iview/src/components/alert'
// import AutoComplete from 'iview/src/components/auto-complete'
import Avatar from 'iview/src/components/avatar'
// import BackTop from 'iview/src/components/back-top'
// import Badge from 'iview/src/components/badge'
// import Breadcrumb from 'iview/src/components/breadcrumb'
import Button from 'iview/src/components/button'
// import Card from 'iview/src/components/card'
import Carousel from 'iview/src/components/carousel'
// import Cascader from 'iview/src/components/cascader'
import Checkbox from 'iview/src/components/checkbox'
// import Circle from 'iview/src/components/circle'
import Collapse from 'iview/src/components/collapse'
// import ColorPicker from 'iview/src/components/color-picker'
import Content from 'iview/src/components/content'
import DatePicker from 'iview/src/components/date-picker'
import Divider from 'iview/src/components/divider'
// import Dropdown from 'iview/src/components/dropdown'
import Footer from 'iview/src/components/footer'
import Form from 'iview/src/components/form'
import Header from 'iview/src/components/header'
import Icon from 'iview/src/components/icon'
import Input from 'iview/src/components/input'
import InputNumber from 'iview/src/components/input-number'
// import Scroll from 'iview/src/components/scroll'
import Layout from 'iview/src/components/layout'
import LoadingBar from 'iview/src/components/loading-bar'
import Menu from 'iview/src/components/menu'
import Message from 'iview/src/components/message'
import Modal from 'iview/src/components/modal'
import Notice from 'iview/src/components/notice'
import Page from 'iview/src/components/page'
// import Poptip from 'iview/src/components/poptip'
// import Progress from 'iview/src/components/progress'
import Radio from 'iview/src/components/radio'
// import Rate from 'iview/src/components/rate'
import Sider from 'iview/src/components/sider'
// import Slider from 'iview/src/components/slider'
import Spin from 'iview/src/components/spin'
// import Steps from 'iview/src/components/steps'
import Switch from 'iview/src/components/switch'
import Table from 'iview/src/components/table'
import Tabs from 'iview/src/components/tabs'
// import Tag from 'iview/src/components/tag'
// import Timeline from 'iview/src/components/timeline'
import TimePicker from 'iview/src/components/time-picker'
import Tooltip from 'iview/src/components/tooltip'
// import Transfer from 'iview/src/components/transfer'
import Tree from 'iview/src/components/tree'
import Upload from 'iview/src/components/upload'
import {
    Row,
    Col
} from 'iview/src/components/grid'
import {
    Select,
    Option,
    OptionGroup
} from 'iview/src/components/select'
import locale from 'iview/src/locale/index'


const components = {
    // Affix,
    Alert,
    // AutoComplete,
    Avatar,
    // BackTop,
    // Badge,
    // Breadcrumb,
    // BreadcrumbItem: Breadcrumb.Item,
    Button,
    // ButtonGroup: Button.Group,
    // Card,
    Carousel,
    CarouselItem: Carousel.Item,
    // Cascader,
    Checkbox,
    CheckboxGroup: Checkbox.Group,
    Col,
    Collapse,
    // ColorPicker,
    Content: Content,
    DatePicker,
    Divider,
    // Dropdown,
    // DropdownItem: Dropdown.Item,
    // DropdownMenu: Dropdown.Menu,
    Footer: Footer,
    Form,
    FormItem: Form.Item,
    Header: Header,
    Icon,
    Input,
    InputNumber,
    // Scroll,
    Sider: Sider,
    Submenu: Menu.Sub,
    Layout: Layout,
    LoadingBar,
    Menu,
    MenuGroup: Menu.Group,
    MenuItem: Menu.Item,
    Message,
    Modal,
    Notice,
    Option: Option,
    OptionGroup,
    Page,
    Panel: Collapse.Panel,
    // Poptip,
    // Progress,
    Radio,
    RadioGroup: Radio.Group,
    // Rate,
    Row,
    Select,
    // Slider,
    Spin,
    // Step: Steps.Step,
    // Steps
    Table,
    Tabs: Tabs,
    TabPane: Tabs.Pane,
    // Tag,
    // Timeline,
    // TimelineItem: Timeline.Item,
    TimePicker,
    Tooltip,
    // Transfer,
    Tree,
    Upload,
    // ICircle: Circle,
    ISwitch: Switch
}

const iview = {
    ...components,
    iButton: Button,
    // iCircle: Circle,
    iCol: Col,
    iContent: Content,
    iForm: Form,
    iFooter: Footer,
    iHeader: Header,
    iInput: Input,
    iMenu: Menu,
    iOption: Option,
    // iProgress: Progress,
    iSelect: Select,
    iSwitch: Switch
    // iTable: Table,
    // iTime: Time
}

const install = function (Vue, opts = {}) {
    if (install.installed) return
    locale.use(opts.locale)
    locale.i18n(opts.i18n)
    
    Object.keys(iview).forEach(key => {
        Vue.component(key, iview[key])
    })
    Vue.prototype.$IVIEW = {
        size: opts.size || '',
        transfer: 'transfer' in opts ? opts.transfer : '',
        select: {
            arrow: opts.select ? opts.select.arrow ? opts.select.arrow : '' : '',
            customArrow: opts.select ? opts.select.customArrow ? opts.select.customArrow : '' : '',
            arrowSize: opts.select ? opts.select.arrowSize ? opts.select.arrowSize : '' : ''
        },
        cell: {
            arrow: opts.cell ? opts.cell.arrow ? opts.cell.arrow : '' : '',
            customArrow: opts.cell ? opts.cell.customArrow ? opts.cell.customArrow : '' : '',
            arrowSize: opts.cell ? opts.cell.arrowSize ? opts.cell.arrowSize : '' : ''
        },
        menu: {
            arrow: opts.menu ? opts.menu.arrow ? opts.menu.arrow : '' : '',
            customArrow: opts.menu ? opts.menu.customArrow ? opts.menu.customArrow : '' : '',
            arrowSize: opts.menu ? opts.menu.arrowSize ? opts.menu.arrowSize : '' : ''
        },
        tree: {
            arrow: opts.tree ? opts.tree.arrow ? opts.tree.arrow : '' : '',
            customArrow: opts.tree ? opts.tree.customArrow ? opts.tree.customArrow : '' : '',
            arrowSize: opts.tree ? opts.tree.arrowSize ? opts.tree.arrowSize : '' : ''
        },
        cascader: {
            arrow: opts.cascader ? opts.cascader.arrow ? opts.cascader.arrow : '' : '',
            customArrow: opts.cascader ? opts.cascader.customArrow ? opts.cascader.customArrow : '' : '',
            arrowSize: opts.cascader ? opts.cascader.arrowSize ? opts.cascader.arrowSize : '' : '',
            itemArrow: opts.cascader ? opts.cascader.itemArrow ? opts.cascader.itemArrow : '' : '',
            customItemArrow: opts.cascader ? opts.cascader.customItemArrow ? opts.cascader.customItemArrow : '' : '',
            itemArrowSize: opts.cascader ? opts.cascader.itemArrowSize ? opts.cascader.itemArrowSize : '' : ''
        },
        colorPicker: {
            arrow: opts.colorPicker ? opts.colorPicker.arrow ? opts.colorPicker.arrow : '' : '',
            customArrow: opts.colorPicker ? opts.colorPicker.customArrow ? opts.colorPicker.customArrow : '' : '',
            arrowSize: opts.colorPicker ? opts.colorPicker.arrowSize ? opts.colorPicker.arrowSize : '' : ''
        },
        datePicker: {
            icon: opts.datePicker ? opts.datePicker.icon ? opts.datePicker.icon : '' : '',
            customIcon: opts.datePicker ? opts.datePicker.customIcon ? opts.datePicker.customIcon : '' : '',
            iconSize: opts.datePicker ? opts.datePicker.iconSize ? opts.datePicker.iconSize : '' : ''
        },
        timePicker: {
            icon: opts.timePicker ? opts.timePicker.icon ? opts.timePicker.icon : '' : '',
            customIcon: opts.timePicker ? opts.timePicker.customIcon ? opts.timePicker.customIcon : '' : '',
            iconSize: opts.timePicker ? opts.timePicker.iconSize ? opts.timePicker.iconSize : '' : ''
        },
        tabs: {
            closeIcon: opts.tabs ? opts.tabs.closeIcon ? opts.tabs.closeIcon : '' : '',
            customCloseIcon: opts.tabs ? opts.tabs.customCloseIcon ? opts.tabs.customCloseIcon : '' : '',
            closeIconSize: opts.tabs ? opts.tabs.closeIconSize ? opts.tabs.closeIconSize : '' : ''
        },
        modal: {
            maskClosable: opts.modal ? 'maskClosable' in opts.modal ? opts.modal.maskClosable : '' : ''
        }
    }
    
    Vue.prototype.$Loading = LoadingBar
    Vue.prototype.$Message = Message
    Vue.prototype.$Modal = Modal
    Vue.prototype.$Notice = Notice
    Vue.prototype.$Spin = Spin
    Notice.config({
        duration: 3.5
    })
}

//auto install
if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue)
}

const API = {
    version: process.env.VERSION,
    locale: locale.use,
    i18n: locale.i18n,
    install,
    Switch,
    ...components
}

API.lang = (code) => {
    const langObject = window['iview/locale'].default
    if (code === langObject.i.locale) locale.use(langObject)
    else console.log(`The ${code} language pack is not loaded.`) // eslint-disable-line no-console
}

export default API



// WEBPACK FOOTER //
// ./src/iView.js